import { useEffect, useState } from "react";

export type YoutubeVideo = {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  publishedAt: string;
  liveBroadcastContent?: string;
};

type YoutubeVideosState = {
  videos: YoutubeVideo[];
  liveVideo: YoutubeVideo | null;
  loading: boolean;
  error: string;
  cached: boolean;
  fetchedAt: string | null;
};

export function useYoutubeVideos(maxResults = 20) {
  const [state, setState] = useState<YoutubeVideosState>({
    videos: [],
    liveVideo: null,
    loading: true,
    error: "",
    cached: false,
    fetchedAt: null,
  });

  useEffect(() => {
    let active = true;

    async function fetchVideos() {
      try {
        setState((current) => ({ ...current, loading: true, error: "" }));

        const response = await fetch(
          `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/youtube-videos?maxResults=${maxResults}`,
          {
            headers: {
              Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
            },
          },
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.error || "Erro ao carregar videos do YouTube.");
        }

        if (!active) return;

        setState({
          videos: result.videos || [],
          liveVideo: result.liveVideo || null,
          loading: false,
          error: "",
          cached: Boolean(result.cached),
          fetchedAt: result.fetchedAt || null,
        });
      } catch (error) {
        if (!active) return;

        setState((current) => ({
          ...current,
          loading: false,
          error: error instanceof Error ? error.message : "Erro ao carregar videos do YouTube.",
        }));
      }
    }

    fetchVideos();

    return () => {
      active = false;
    };
  }, [maxResults]);

  return state;
}
